import { PureComponent } from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { connect } from 'react-redux';

import Flag from '@atlaskit/flag';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';

import { showNewCommits } from 'src/redux/commit-list';
import { ComponentFlagId } from 'src/redux/flags/types';

import { messages as i18n } from './i18n';

type Props = {
  id: ComponentFlagId | string;
  showNewCommits: typeof showNewCommits;
  intl: IntlShape;
};

export class UpdatedCommitsListFlag extends PureComponent<Props> {
  showNewCommits = () => {
    this.props.showNewCommits();
  };

  render() {
    const actions = [
      {
        content: <FormattedMessage {...i18n.showUpdatedCommits} />,
        onClick: this.showNewCommits,
      },
    ];

    return (
      <Flag
        actions={actions}
        icon={
          <StatusInformationIcon
            spacing="spacious"
            color={token('color.icon.information')}
            label="Info"
          />
        }
        title={<FormattedMessage {...i18n.title} />}
        {...this.props}
      />
    );
  }
}

const mapDispatchToProps = {
  showNewCommits,
};

// eslint-disable-next-line import/no-default-export
export default connect(
  null,
  mapDispatchToProps
)(injectIntl(UpdatedCommitsListFlag));
